module.exports = __webpack_public_path__ + "img/Rubis.c41ec82b.png";